var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsClose = function SvgIconsClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.922 2.12l.053.047L6 5.191l3.025-3.024c.223-.223.584-.223.808 0 .206.206.221.53.047.755l-.047.053L6.809 6l3.024 3.025c.223.223.223.584 0 .808-.206.206-.53.221-.755.047l-.053-.047L6 6.809 2.975 9.833c-.223.223-.584.223-.808 0-.206-.206-.221-.53-.047-.755l.047-.053L5.191 6 2.167 2.975c-.223-.223-.223-.584 0-.808.206-.206.53-.221.755-.047z"
  })));
};
export default SvgIconsClose;